import React from 'react';
import { Select, TextInput } from '@mantine/core';
import { Button } from '../../../components/Button';
import {
  DATE_FILTER_OPTIONS,
  TENBIS_DIRECTION_OPTIONS,
  TENBIS_KIND_OPTIONS,
  TENBIS_STATUS_OPTIONS,
  type DateFilterMode,
} from '../monitoring-page.constants';
import type { UseMonitoringPage } from '../useMonitoringPage';
import classes from '../monitoring-page.module.scss';

type TenbisCallLogsFiltersProps = Pick<
  UseMonitoringPage,
  | 'tenbisTenantFilter' | 'setTenbisTenantFilter'
  | 'tenbisTenantOptions'
  | 'tenbisDirectionFilter' | 'setTenbisDirectionFilter'
  | 'tenbisKindFilter' | 'setTenbisKindFilter'
  | 'tenbisStatusFilter' | 'setTenbisStatusFilter'
  | 'tenbisSearch' | 'setTenbisSearch'
  | 'tenbisDateFilterMode' | 'setTenbisDateFilterMode'
  | 'tenbisExactDate' | 'setTenbisExactDate'
  | 'tenbisDateFrom' | 'setTenbisDateFrom'
  | 'tenbisDateTo' | 'setTenbisDateTo'
  | 'clearTenbisFilters'
>;

export const TenbisCallLogsFilters: React.FC<TenbisCallLogsFiltersProps> = ({
  tenbisTenantFilter,
  setTenbisTenantFilter,
  tenbisTenantOptions,
  tenbisDirectionFilter,
  setTenbisDirectionFilter,
  tenbisKindFilter,
  setTenbisKindFilter,
  tenbisStatusFilter,
  setTenbisStatusFilter,
  tenbisSearch,
  setTenbisSearch,
  tenbisDateFilterMode,
  setTenbisDateFilterMode,
  tenbisExactDate,
  setTenbisExactDate,
  tenbisDateFrom,
  setTenbisDateFrom,
  tenbisDateTo,
  setTenbisDateTo,
  clearTenbisFilters,
}) => (
  <div className={classes.filtersCard}>
    <div className={classes.filtersGridKitchen}>
      <div className={classes.fieldStack}>
        <Select
          label={'עסק'}
          placeholder={'בחר עסק'}
          data={tenbisTenantOptions}
          value={tenbisTenantFilter || null}
          onChange={(value) => setTenbisTenantFilter(value ?? '')}
          searchable
          clearable
          data-testid="monitoring-tenbis-filter-tenant"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'כיוון'}
          placeholder={'בחר כיוון'}
          data={TENBIS_DIRECTION_OPTIONS}
          value={tenbisDirectionFilter || null}
          onChange={(value) => setTenbisDirectionFilter(value ?? '')}
          clearable
          data-testid="monitoring-tenbis-filter-direction"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סוג'}
          placeholder={'בחר סוג'}
          data={TENBIS_KIND_OPTIONS}
          value={tenbisKindFilter || null}
          onChange={(value) => setTenbisKindFilter(value ?? '')}
          clearable
          data-testid="monitoring-tenbis-filter-kind"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סטטוס'}
          placeholder={'בחר סטטוס'}
          data={TENBIS_STATUS_OPTIONS}
          value={tenbisStatusFilter || null}
          onChange={(value) => setTenbisStatusFilter(value ?? '')}
          clearable
          data-testid="monitoring-tenbis-filter-status"
        />
      </div>

      <div className={classes.fieldStack}>
        <TextInput
          label={'חיפוש'}
          placeholder={'שגיאה או מזהה בקשה'}
          value={tenbisSearch}
          onChange={(event) => setTenbisSearch(event.currentTarget.value)}
          data-testid="monitoring-tenbis-filter-search"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סינון תאריך'}
          data={DATE_FILTER_OPTIONS}
          value={tenbisDateFilterMode}
          onChange={(value) => setTenbisDateFilterMode((value as DateFilterMode) ?? 'all')}
          allowDeselect={false}
          data-testid="monitoring-tenbis-date-mode"
        />
        {tenbisDateFilterMode === 'exact' && (
          <TextInput type="date" value={tenbisExactDate} onChange={(event) => setTenbisExactDate(event.currentTarget.value)} data-testid="monitoring-tenbis-date-exact" />
        )}
        {tenbisDateFilterMode === 'between' && (
          <div className={classes.fieldRow}>
            <TextInput type="date" value={tenbisDateFrom} onChange={(event) => setTenbisDateFrom(event.currentTarget.value)} data-testid="monitoring-tenbis-date-from" />
            <TextInput type="date" value={tenbisDateTo} onChange={(event) => setTenbisDateTo(event.currentTarget.value)} data-testid="monitoring-tenbis-date-to" />
          </div>
        )}
      </div>
    </div>

    <div className={classes.filtersActions}>
      <Button variant="cancel" onClick={clearTenbisFilters} dataTestId="monitoring-tenbis-clear-filters">
        {'נקה סינונים'}
      </Button>
    </div>
  </div>
);
